import Cookies from 'js-cookie'
import api from '@/utils/api'

const state = {
  sidebar: {
    opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
    withoutAnimation: false
  },
  device: 'desktop',
  size: Cookies.get('size') || 'medium',
  userList: [], // 用户下拉
  salesmanList: [], // 业务员下拉
  orgList: [], // 机构及联
  validateCode: '', // 验车码
  carType: [],
  carBigType: [],
  receiptType: [],
  useType: [],
  checkInfo: [],
}

const mutations = {
  TOGGLE_SIDEBAR: state => {
    state.sidebar.opened = !state.sidebar.opened
    state.sidebar.withoutAnimation = false
    if (state.sidebar.opened) {
      Cookies.set('sidebarStatus', 1)
    } else {
      Cookies.set('sidebarStatus', 0)
    }
  },
  CLOSE_SIDEBAR: (state, withoutAnimation) => {
    Cookies.set('sidebarStatus', 0)
    state.sidebar.opened = false
    state.sidebar.withoutAnimation = withoutAnimation
  },
  TOGGLE_DEVICE: (state, device) => {
    state.device = device
  },
  SET_SIZE: (state, size) => {
    state.size = size
    Cookies.set('size', size)
  },
  // 全部工号
  SET_USER_LIST(state, payload) {
    state.userList = [...payload]
  },
  // 全部业务员
  SET_SALESMANLIST(state, payload) {
    state.salesmanList = [...payload]
  },
  // 机构数据
  SET_ORG_LIST(state, payload) {
    state.orgList = [...payload]
  },
  // 验车码
  SET_VALIDATE_CODE(state, payload) {
    state.validateCode = payload
  },
  // 车辆类型
  SET_CAR_TYPE(state, payload) {
    state.carType = payload
  },
  // 车辆大类
  SET_CAR_BIG_TYPE(state, payload) {
    state.carBigType = payload
  },
  // 财务补录付款方式
  SET_RECEIPT_TYPE(state, payload) {
    state.receiptType = payload
  },
  // 营运性质
  SET_USE_TYPE(state, payload) {
    state.useType = payload
  },
  // 验车提示
  SET_CHECK_INFO(state, payload) {
    state.checkInfo = payload
  },
}

const actions = {
  toggleSideBar({ commit }) {
    commit('TOGGLE_SIDEBAR')
  },
  closeSideBar({ commit }, { withoutAnimation }) {
    commit('CLOSE_SIDEBAR', withoutAnimation)
  },
  toggleDevice({ commit }, device) {
    commit('TOGGLE_DEVICE', device)
  },
  setSize({ commit }, size) {
    commit('SET_SIZE', size)
  },
  // 获取全部用户
  async getUserList({commit}) {
    const res = await api.post('/admin/admin/getAllUser', { user_type: 0 })
    console.log(res)
    const list = res.data.map(item => ({...item, label: item.realname, value: item.id}))
    commit('SET_USER_LIST', list)
  },
  // 获取业务员
  async getSalemanList({commit}) {
    const res = await api.post('/admin/admin/getAllUser', { user_type: 1 })
    const list = res.data.map(item => ({...item, label: item.realname, value: item.id}))
    commit('SET_SALESMANLIST', list)
  },
  // 获取所有机构
  async getOrgList({ commit }) {
    const res = await api.post('/admin/org/index')
    commit('SET_ORG_LIST', res.data.data)
  } ,
  // 获取验证码
  async getValidateCode({ commit }) {
    const res = await api.post('/admin/other/getcode')
    commit('SET_VALIDATE_CODE', res.data.code)
  },
  // 获取车辆类型
  async getCarType({ commit }) {
    const res = await api.post('/admin/dict/index', {dictType: 5})
    const list  = res.data.data.map(item => ({ ...item, label: item.dictName, value: item.dictValue}))
    commit('SET_CAR_TYPE', list)
  },
  // 获取车辆大类
  async getCarBigType({ commit }) {
    const res = await api.post('/admin/dict/index', {dictType: 6})
    const list  = res.data.data.map(item => ({ ...item, label: item.dictName, value: item.dictValue}))
    commit('SET_CAR_BIG_TYPE', list)
  },
  // 获取财务补录付款方式
  async getReceiptType({ commit }) {
    const res = await api.post('/admin/dict/index', {dictType: 7})
    const list  = res.data.data.map(item => ({ ...item, label: item.dictName, value: item.dictValue}))
    commit('SET_RECEIPT_TYPE', list)
  },
  // 获取营运性质
  async getUseType({ commit }) {
    const res = await api.post('/admin/dict/index', {dictType: 9})
    const list  = res.data.data.map(item => ({ ...item, label: item.dictName, value: item.dictValue}))
    commit('SET_USE_TYPE', list)
  },
  // 获取验车提示
  async getCheckInfo({ commit }) {
    const res = await api.post('/admin/dict/index', {dictType: 10})
    const list  = res.data.data.map(item => ({ ...item, label: item.dictName, value: item.dictValue}))
    commit('SET_CHECK_INFO', list)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
